import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface GetPowerAnalysisResponse {
    totalUsage: {
        overall: {
            currentTotalUsage: number;
            lastWeekSameDayUsage: number;
            ratio: number;
        };
        floors: {
            floorId: number;
            floorName: string;
            currentTotalUsage: number;
            lastWeekSameDayUsage: number;
            ratio: number;
        }[];
    };
    carbonEmission: {
        currentEmission: number;
        lastWeekEmission: number;
        ratio: number;
    };
    contractCapacity: {
        contractCapacityValue: number;
        currentLoadKw: number;
        ratio: number;
        isAlarm: boolean;
        sampledAt: string;
    };
    sampledAt:string;
}

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    private http = inject(HttpClient);
    private readonly baseUrl = environment.apiUrl + '/api/Dashboards';

    /**
     * 取得電力綜合分析指標
     * @returns PowerAnalysisDto
     */
    apiGetPowerAnalysis() {
        return this.http.get<GetPowerAnalysisResponse>(`${this.baseUrl}/PowerAnalysis`);
    }
}
